import React from 'react';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { ScrollPage } from './pages/ScrollPage';
const theme = extendTheme({
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false
  },
  styles: {
    global: {
      body: {
        bg: 'var(--white)',
        color: 'var(--ink)',
        fontFamily: 'var(--sans)'
      }
    }
  },
  fonts: {
    heading: 'var(--serif)',
    body: 'var(--sans)',
    mono: 'var(--mono)'
  },
  components: {
    Button: {
      baseStyle: {
        borderRadius: '4px',
        fontFamily: 'var(--sans)'
      }
    }
  }
});
export function App() {
  return <ChakraProvider theme={theme} data-id="element-0">
      <ScrollPage data-id="element-1" />
    </ChakraProvider>;
}